module.exports = __webpack_public_path__ + "img/icon-clients-white.ba8cf699.svg";